import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import fileextension from 'file-extension'
import { AUDIO_EXT } from '../../utils'
import AudioView from '../assets-view/AudioView'
import DocumentView from '../document-view/DocumentView'
import VideoView from '../assets-view/VideoView'
import { Tooltip } from 'antd'
import moment from 'moment'
import { SVGView } from '../assets-view/SVGView'
import {

  handleSetSrc
} from '../../utils/index'
import MainVersionsAlerts from './MainVersionsAlerts'

export class MainVersionsList extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  componentDidUpdate(prevProps) { }

  render() {
    const {
      intl,
      isShowCompareVersion,
      showModalDeleteVersion,
      showModalSelectVersion,
      showModalDeleteMedia,
      showModalDeleteStatus,
      showModalDeleteComment,
      commentDelete,
      itemSelected,
      itemsVersionsForCompare,
    } = this.props

    let actualVersionDate = null
    if (itemSelected && itemSelected.document) {
      if (
        !itemSelected.document.lastUploadDate &&
        itemSelected.versions.length === 0
      ) {
        actualVersionDate = itemSelected.document.createdAt
      } else {
        actualVersionDate = itemSelected.document.lastUploadDate
      }
    }

    const ALERTS_MODALS = [
      {
        show: showModalDeleteVersion,
        confirm: this.props.deleteVersion,
        notConfirm: this.props.hideDeleteVersion,
        textId: 'version_will_no_longer_available',
      },
      {
        show: showModalSelectVersion,
        confirm: this.props.setSelectVersion,
        notConfirm: this.props.hideSelectVersion,
        textId: 'define_current_version_question',
      },
      {
        show: showModalDeleteMedia,
        confirm: this.props.deleteMedia,
        notConfirm: this.props.closeModalDeleteMedia,
        textId: 'permanently_remove_stamp_question',
        isTextSmall: true,
        textIdSmall: 'permanently_remove_stamp_warning',
      },
      {
        show: showModalDeleteStatus,
        confirm: this.props.deleteStatus,
        notConfirm: this.props.closeModalDeleteMedia,
        textId: 'permanently_remove_status_question',
        isTextSmall: true,
        textIdSmall: 'permanently_remove_status_warning',
      },
      {
        show: showModalDeleteComment,
        confirm: this.props.handleDeleteComment,
        notConfirm: this.props.closeModalDeleteComment,
        textId: 'question_delete_comment',
        isTextSmall: true,
        textIdSmall: 'check_delete_comment',
        params: { commentId: commentDelete },
      },
    ]

    return (
      <div
        className="bb-history__items"
        style={{ height: 'calc(100vh - 210px)' }}
      >
        <div className="items-scroll">
          {/*.active*/}

          {ALERTS_MODALS.map((a, k) => {
            return (
              <MainVersionsAlerts
                //Keys
                key={k}
                //Variables
                show={a.show}
                textId={a.textId}
                isTextSmall={a.isTextSmall}
                textIdSmall={a.textIdSmall}
                params={a.params}
                //Funciones
                confirm={a.confirm}
                notConfirm={a.notConfirm}
              />
            )
          })}

          {/** VERSION ACTUAL */}
          <div className="bb-history__item select">
            <figure>
              {
                itemSelected.document.type === 'image' && fileextension(itemSelected.document.originalURL) === 'svg'
                  ? <div className='svg-box-main-versions'><SVGView src={itemSelected.document.originalURL} assetId={itemSelected.document._id} /></div>
                  : itemSelected.document.type === 'image' &&
                    fileextension(itemSelected.document.originalURL) !== 'png' ? (
                    <img
                      alt={itemSelected.document.name}
                      // src={itemSelected.document.lowQualityURL}
                      src={handleSetSrc(itemSelected.document)}
                    />
                  ) : (
                    itemSelected.document.type === 'image' && (
                      <img
                        alt={itemSelected.document.name}
                        src={itemSelected.document.lowQualityURL}
                      />
                    )
                  )}
              {itemSelected.document.type === 'document' &&
                AUDIO_EXT.includes(
                  fileextension(itemSelected.document.originalURL)
                ) && (
                  <div style={{ padding: '25px' }}>
                    <AudioView
                      item={itemSelected.document}
                      from={`middleView`}
                      canCommentsAndVersions={true}
                    />
                  </div>
                )}
              {itemSelected.document.type === 'document' &&
                !AUDIO_EXT.includes(
                  fileextension(itemSelected.document.originalURL)
                ) && (
                  <DocumentView
                    item={itemSelected.document}
                    from={`middleView`}
                  />
                )}
              {itemSelected.document.type === 'audio' &&
                AUDIO_EXT.includes(
                  fileextension(itemSelected.document.originalURL)
                ) && (
                  <div style={{ padding: '25px' }}>
                    <AudioView
                      item={itemSelected.document}
                      from={`middleView`}
                      canCommentsAndVersions={true}
                    />
                  </div>
                )}
              {itemSelected.document.type === 'video' && (
                <div
                  style={{
                    margin: '13px',
                    marginBottom: '1%',
                    width: '250px',
                  }}
                >
                  <VideoView
                    url={itemSelected.document.lowQualityURL}
                    disableDefaultControls={false}
                    autoPlay={false}
                    muted={false}
                  />
                </div>
              )}
              {itemSelected.document.type === 'font' && (
                <DocumentView
                  item={itemSelected.document}
                  from={`middleView`}
                />
              )}
              {isShowCompareVersion && (
                <input
                  type="checkbox"
                  checked={itemsVersionsForCompare.includes(
                    itemSelected.document._id.toString()
                  )}
                  name={itemSelected.document._id.toString()}
                  onChange={() =>
                    this.props.addItemsForCompare(
                      itemSelected.document._id.toString()
                    )
                  }
                />
              )}

              {isShowCompareVersion &&
                itemsVersionsForCompare.includes(
                  itemSelected.document._id.toString()
                ) && (
                  <span className="count">
                    {itemsVersionsForCompare.indexOf(
                      itemSelected.document._id.toString()
                    ) + 1}
                  </span>
                )}

              <span className={isShowCompareVersion ? '' : 'select'}>
                <svg
                  width={18}
                  height={16}
                  viewBox="0 0 18 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 9.69681L7.89621 14L17 1"
                    stroke="white"
                    strokeWidth={2}
                  />
                </svg>
              </span>
            </figure>
            <div className="item-info">
              <ul>
                <li>
                  <strong>
                    <Tooltip
                      placement="bottom"
                      title={itemSelected.document.name}
                    >
                      {itemSelected.document.name.length > 45
                        ? `${itemSelected.document.name
                          .toString()
                          .substring(0, 45)}...`
                        : itemSelected.document.name}
                    </Tooltip>
                  </strong>
                </li>
                <li>
                  {intl.formatMessage({
                    id: 'version',
                  })}
                  :{' '}
                  <strong>
                    {itemSelected.document.versionNumber}
                    {' (Actual)'}
                  </strong>
                </li>
                <li>
                  {intl.formatMessage({
                    id: 'uploaded_by',
                  })}
                  :{' '}
                  {itemSelected.userCreator ? (
                    <strong>{itemSelected.userCreator.name}</strong>
                  ) : (
                    'n/a'
                  )}
                </li>
                <li>
                  {intl.formatMessage({
                    id: 'upload_date',
                  })}
                  :{' '}
                  {itemSelected.document ? (
                    <strong>
                      {actualVersionDate
                        ? moment(actualVersionDate).format('DD/MM/YYYY')
                        : intl.formatMessage({ id: 'undefined' })}
                    </strong>
                  ) : (
                    'n/a'
                  )}
                </li>
                <li>
                  {intl.formatMessage({
                    id: 'upload_time',
                  })}
                  :{' '}
                  {itemSelected.document ? (
                    <strong>
                      {actualVersionDate
                        ? moment(actualVersionDate).format('HH:mm:ss')
                        : intl.formatMessage({ id: 'undefined' })}
                    </strong>
                  ) : (
                    'n/a'
                  )}
                </li>
              </ul>
            </div>
          </div>

          {/** DEMAS VERSIONES */}
          {itemSelected.versions &&
            itemSelected.versions
              .filter(
                (v) => v.versionNumber !== itemSelected.document.versionNumber
              )
              .map((v, k) => (
                <div
                  className={
                    isShowCompareVersion
                      ? 'bb-history__item select'
                      : 'bb-history__item'
                  }
                  key={k}
                >
                  <figure>
                    {
                      v.document.type === 'image' && fileextension(v.document.originalURL) === 'svg'
                        ? <div className='svg-box-main-versions'><SVGView comFromMiddleView={true} src={v.document.originalURL} assetId={v.document._id} /></div>
                        : v.document.type === 'image' &&
                          fileextension(v.document.originalURL) !== 'png' ? (
                          <img
                            alt={v.document.name}
                            // src={v.document.mediaQualityURL}
                            src={handleSetSrc(v.document)}
                          />
                        ) : (
                          v.document.type === 'image' && (
                            <img
                              alt={v.document.name}
                              src={v.document.mediaQualityURL}
                            />
                          )
                        )}
                    {v.document.type === 'document' &&
                      AUDIO_EXT.includes(
                        fileextension(v.document.originalURL)
                      ) && (
                        <div style={{ padding: '25px' }}>
                          <AudioView
                            item={v.document}
                            from={`middleView`}
                            canCommentsAndVersions={true}
                          />
                        </div>
                      )}
                    {v.document.type === 'document' &&
                      !AUDIO_EXT.includes(
                        fileextension(v.document.originalURL)
                      ) && (
                        <DocumentView item={v.document} from={`middleView`} />
                      )}
                    {v.document.type === 'audio' &&
                      AUDIO_EXT.includes(
                        fileextension(v.document.originalURL)
                      ) && (
                        <div style={{ padding: '25px' }}>
                          <AudioView
                            item={v.document}
                            from={`middleView`}
                            canCommentsAndVersions={true}
                          />
                        </div>
                      )}
                    {v.document.type === 'video' && (
                      <div
                        style={{
                          margin: '13px',
                          marginBottom: '1%',
                          width: '250px',
                        }}
                      >
                        <VideoView
                          url={v.document.mediaQualityURL}
                          disableDefaultControls={false}
                          autoPlay={false}
                          muted={false}
                          canCommentsAndVersions={true}
                        />
                      </div>
                    )}
                    {isShowCompareVersion && (
                      <input
                        type="checkbox"
                        checked={itemsVersionsForCompare.includes(
                          v._id.toString()
                        )}
                        name={v._id.toString()}
                        onChange={() =>
                          this.props.addItemsForCompare(v._id.toString())
                        }
                      />
                    )}

                    {isShowCompareVersion &&
                      itemsVersionsForCompare.includes(v._id.toString()) && (
                        <span className="count">
                          {itemsVersionsForCompare.indexOf(v._id.toString()) +
                            1}
                        </span>
                      )}

                    {!isShowCompareVersion && (
                      <div>
                        <span
                          className="remove"
                          onClick={() => this.props.showDeleteVersion(v._id)}
                        >
                          <svg
                            width={11}
                            height={15}
                            viewBox="0 0 11 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 14L10.1038 1"
                              stroke="white"
                              strokeWidth={2}
                            />
                            <path
                              d="M10 14L0.89621 1"
                              stroke="white"
                              strokeWidth={2}
                            />
                          </svg>
                        </span>
                        <span
                          className="select"
                          onClick={() => this.props.showSelectVersion(v._id)}
                        >
                          <svg
                            width={18}
                            height={16}
                            viewBox="0 0 18 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 9.69681L7.89621 14L17 1"
                              stroke="white"
                              strokeWidth={2}
                            />
                          </svg>
                        </span>
                      </div>
                    )}
                  </figure>
                  <div className="item-info">
                    <ul>
                      <li>
                        <strong>
                          <Tooltip placement="bottom" title={v.document.name}>
                            {v.document.name.length > 45
                              ? `${v.document.name
                                .toString()
                                .substring(0, 45)}...`
                              : v.document.name}
                          </Tooltip>
                        </strong>
                      </li>
                      <li>
                        {intl.formatMessage({
                          id: 'version',
                        })}
                        : <strong> {v.versionNumber}</strong>
                      </li>
                      <li>
                        {intl.formatMessage({
                          id: 'uploaded_by',
                        })}
                        :{' '}
                        <strong>
                          {v.uploaderUser ? v.uploaderUser.name : 'n/a'}
                        </strong>
                      </li>
                      <li>
                        {intl.formatMessage({
                          id: 'upload_date',
                        })}
                        :{' '}
                        {v.document.lastUploadDate ? (
                          <strong>
                            {moment(v.document.lastUploadDate).format(
                              'DD/MM/YYYY'
                            )}
                          </strong>
                        ) : (
                          <strong>
                            {intl.formatMessage({
                              id: 'undefined',
                            })}
                          </strong>
                        )}
                      </li>
                      <li>
                        {intl.formatMessage({ id: 'upload_time' })}
                        :&nbsp;
                        {v.document.lastUploadDate ? (
                          <strong>
                            {moment(v.document.lastUploadDate).format(
                              'HH:mm:ss'
                            )}
                          </strong>
                        ) : (
                          <strong>
                            {intl.formatMessage({
                              id: 'undefined',
                            })}
                          </strong>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
              ))}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const obj = {
    itemSelected: state.comments.itemSelected,
  }

  return obj
}

const mapDispatchToProps = {}

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(MainVersionsList))
)
